import { createSlice } from '@reduxjs/toolkit';
import { resetApplication } from '../application/slice';
import edgeEventsState from './state';
export const edgeEventsSlice = createSlice({
    extraReducers: builder => {
        builder.addCase(resetApplication, () => edgeEventsState);
    },
    initialState: edgeEventsState,
    name: 'edgeEvents',
    reducers: {
        errorReceiveEdgeEventsAlerts: state => {
            state.edgeEventsAlerts = undefined;
            state.requestingEdgeEventsAlerts = false;
        },
        errorReceiveEdgeEventsRules: state => {
            state.edgeEventsRules = undefined;
            state.requestingEdgeEventsRules = false;
        },
        errorReceiveEdgeEventsSites: state => {
            state.edgeEventsSites = undefined;
            state.requestingEdgeEventsSites = false;
        },
        errorReceiveModifyEdgeEventsAlert: state => {
            state.requestingModifyEdgeEventsAlert = false;
        },
        errorReceiveRemoveEdgeEventsAlert: state => {
            state.requestingRemoveEdgeEventsAlert = false;
        },
        errorReceiveSetEdgeEventsAlert: state => {
            state.requestingSetEdgeEventsAlert = false;
        },
        failedReceiveEdgeEventsAlerts: state => {
            state.edgeEventsAlerts = undefined;
            state.requestingEdgeEventsAlerts = false;
        },
        failedReceiveEdgeEventsRules: state => {
            state.edgeEventsRules = undefined;
            state.requestingEdgeEventsRules = false;
        },
        failedReceiveEdgeEventsSites: state => {
            state.edgeEventsSites = undefined;
            state.requestingEdgeEventsSites = false;
        },
        failedReceiveModifyEdgeEventsAlert: state => {
            state.requestingModifyEdgeEventsAlert = false;
        },
        failedReceiveRemoveEdgeEventsAlert: state => {
            state.requestingRemoveEdgeEventsAlert = false;
        },
        failedReceiveSetEdgeEventsAlert: state => {
            state.requestingSetEdgeEventsAlert = false;
        },
        receiveEdgeEventsAlerts: {
            prepare: edgeEventsAlerts => {
                return {
                    payload: {
                        edgeEventsAlerts
                    }
                };
            },
            reducer: (state, action) => {
                const { edgeEventsAlerts } = action.payload;
                state.edgeEventsAlerts = edgeEventsAlerts;
                state.requestingEdgeEventsAlerts = false;
            }
        },
        receiveEdgeEventsRules: {
            prepare: edgeEventsRules => {
                return {
                    payload: {
                        edgeEventsRules
                    }
                };
            },
            reducer: (state, action) => {
                const { edgeEventsRules } = action.payload;
                state.edgeEventsRules = edgeEventsRules;
                state.requestingEdgeEventsRules = false;
            }
        },
        receiveEdgeEventsSites: {
            prepare: edgeEventsSites => {
                return {
                    payload: {
                        edgeEventsSites
                    }
                };
            },
            reducer: (state, action) => {
                const { edgeEventsSites } = action.payload;
                state.edgeEventsSites = edgeEventsSites;
                state.requestingEdgeEventsSites = false;
            }
        },
        receiveModifyEdgeEventsAlert: {
            prepare: alert => {
                return {
                    payload: {
                        alert
                    }
                };
            },
            reducer: (state, action) => {
                const { alert } = action.payload;
                state.edgeEventsAlerts = state.edgeEventsAlerts.map(value => {
                    return value.name === alert.name ? alert : value;
                });
                state.requestingModifyEdgeEventsAlert = false;
            }
        },
        receiveRemoveEdgeEventsAlert: {
            prepare: alertName => {
                return {
                    payload: {
                        alertName
                    }
                };
            },
            reducer: (state, action) => {
                const { alertName } = action.payload;
                state.edgeEventsAlerts = state.edgeEventsAlerts.filter(value => {
                    return value.name !== alertName;
                });
                state.requestingRemoveEdgeEventsAlert = false;
            }
        },
        receiveSetEdgeEventsAlert: {
            prepare: alert => {
                return {
                    payload: {
                        alert
                    }
                };
            },
            reducer: (state, action) => {
                const { alert } = action.payload;
                state.edgeEventsAlerts.push(alert);
                state.requestingSetEdgeEventsAlert = false;
            }
        },
        requestEdgeEventsAlerts: state => {
            state.requestingEdgeEventsAlerts = true;
        },
        requestEdgeEventsRules: state => {
            state.requestingEdgeEventsRules = true;
        },
        requestEdgeEventsSites: state => {
            state.requestingEdgeEventsSites = true;
        },
        requestModifyEdgeEventsAlert: {
            prepare: alertPayload => {
                return {
                    payload: {
                        alertPayload
                    }
                };
            },
            reducer: state => {
                state.requestingModifyEdgeEventsAlert = true;
            }
        },
        requestRemoveEdgeEventsAlert: {
            prepare: alertPayload => {
                return {
                    payload: {
                        alertPayload
                    }
                };
            },
            reducer: state => {
                state.requestingRemoveEdgeEventsAlert = true;
            }
        },
        requestSetEdgeEventsAlert: {
            prepare: alertPayload => {
                return {
                    payload: {
                        alertPayload
                    }
                };
            },
            reducer: state => {
                state.requestingSetEdgeEventsAlert = true;
            }
        },
        resetEdgeEvents: () => edgeEventsState
    }
});
export const { errorReceiveEdgeEventsAlerts, errorReceiveEdgeEventsRules, errorReceiveEdgeEventsSites, errorReceiveModifyEdgeEventsAlert, errorReceiveRemoveEdgeEventsAlert, errorReceiveSetEdgeEventsAlert, failedReceiveEdgeEventsAlerts, failedReceiveEdgeEventsRules, failedReceiveEdgeEventsSites, failedReceiveModifyEdgeEventsAlert, failedReceiveRemoveEdgeEventsAlert, failedReceiveSetEdgeEventsAlert, receiveEdgeEventsAlerts, receiveEdgeEventsRules, receiveEdgeEventsSites, receiveModifyEdgeEventsAlert, receiveRemoveEdgeEventsAlert, receiveSetEdgeEventsAlert, requestEdgeEventsAlerts, requestEdgeEventsRules, requestEdgeEventsSites, requestModifyEdgeEventsAlert, requestRemoveEdgeEventsAlert, requestSetEdgeEventsAlert, resetEdgeEvents } = edgeEventsSlice.actions;
export default edgeEventsSlice.reducer;
